import { isSegmentIncludedInPerformanceStats, shiftAggregateSchema, } from '@der-maschinfuehrer/contracts';
export function derivePerformanceStats(aggregateInputs) {
    const aggregates = aggregateInputs.map((aggregate) => shiftAggregateSchema.parse(aggregate));
    const liveAggregates = aggregates.filter((aggregate) => aggregate.shift.metadata.tombstone === null);
    const serviceDays = new Set();
    let tripCount = 0;
    let confirmedDistanceMetres = 0;
    let durationMilliseconds = 0;
    let incompleteDurationCount = 0;
    let invalidDurationCount = 0;
    for (const aggregate of liveAggregates) {
        let shiftContributes = false;
        for (const segment of aggregate.segments) {
            if (!isSegmentIncludedInPerformanceStats(segment)) {
                continue;
            }
            shiftContributes = true;
            tripCount += 1;
            if (segment.distance_metres !== null &&
                segment.route_snapshot?.distance.quality === 'confirmed') {
                confirmedDistanceMetres += segment.distance_metres;
            }
            if (segment.actual_start === null || segment.actual_end === null) {
                incompleteDurationCount += 1;
            }
            else {
                const duration = Date.parse(segment.actual_end.instant) - Date.parse(segment.actual_start.instant);
                if (duration < 0) {
                    invalidDurationCount += 1;
                }
                else {
                    durationMilliseconds += duration;
                }
            }
        }
        if (shiftContributes) {
            serviceDays.add(aggregate.shift.service_date);
        }
    }
    return {
        shift_count: liveAggregates.filter((aggregate) => aggregate.segments.some((segment) => isSegmentIncludedInPerformanceStats(segment))).length,
        trip_count: tripCount,
        service_day_count: serviceDays.size,
        confirmed_distance_metres: confirmedDistanceMetres,
        duration_milliseconds: durationMilliseconds,
        incomplete_duration_count: incompleteDurationCount,
        invalid_duration_count: invalidDurationCount,
    };
}
//# sourceMappingURL=stats.js.map